//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      shopMsg:'',
      manager:'全部',
      managerList:[
        {value:'全部',label:'全部'},
        {value:'1',label:'经理1'},
        {value:'2',label:'经理2'},
      ],
      initShopArea:'全部',
      shopAreaList:[],
      initShopBrand:'全部',
      shopBrandList:[],
      addGoodsState:false,
      tableData:[
      ],
      imageUrl: '',
      file:{},//头像
      pageSizes:[5, 10, 15, 20],
      pageSizeValue:15,
      total:0,
      pageNo:1,
    }
  },
  mounted(){
    this.info()
    // this.infoGoodsTypeList()
  },
  methods: {
    info(state = false){
      if(state){
        this.pageNo = 1
      }
      let data = {
        pageNo:this.pageNo,
        pageSize:this.pageSizeValue,
        dealerId:window.sessionStorage.getItem('dealerId'),
      }
      if(this.shopMsg !== ''){
        data.goodsName = this.shopMsg
      }
      this.tableData = []
      this.total = 0
      this.$axios.post('/mtea/stock/dealer/goodsSearch', data).then(res => {
        console.log(res)
        this.tableData =res.records
        this.total = res.total
      })
    },
    // infoGoodsTypeList(){
    //   this.$axios.get('/mtea/store/admin/goods/category/list',{params:{}}).then(res=>{
    //     this.shopBrandList = res
    //     this.shopBrandList.unshift({name:'全部',categoryId:'全部'})
    //   })
    //   this.$axios.get('/mtea/store/admin/goods/brand/list',{params:{}}).then(res=>{
    //     this.shopAreaList = res
    //     this.shopAreaList.unshift({name:'全部',brandId:'全部'})
    //   })
    // },
    handleClick(row){
      console.log(row)
      this.addGoodsState = true
    },
        cellStyel(){
      let style = {}
      style['text-align'] = 'center'
      return style
    },
    headerCellStyel(){
      let style = {}
      style['text-align'] = 'center'
      style['background-color'] = '#f2f2f2'
      return style
    },

    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    fileChange (file, fileList) {
      this.imageUrl = URL.createObjectURL(file.raw)
      if (fileList.length > 0) {
        this.file = file.raw
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    sizeChange(num){
      this.pageSizeValue = num
      this.info()
    },
    currentChange(num){
      this.pageNo = num
      this.info()
    },
  },
}
